const parseText = (text: string | undefined): { text: string; height: number; width: number } => {
  if (!text) return { text: '', height: 0, width: 1 };

  let height = 2.5; // Default height
  let width = 1.0;  // Default width ratio
  let cleanText = text;

  // Extract all height parameters and use the last one (most recent)
  const heightMatches = text.match(/\\H([0-9.]+);/g);
  if (heightMatches) {
    const lastHeight = heightMatches[heightMatches.length - 1].match(/\\H([0-9.]+);/);
    if (lastHeight) {
      height = parseFloat(lastHeight[1]);
    }
  }

  // Extract width parameter
  const widthMatch = text.match(/\\W([0-9.]+);/);
  if (widthMatch) {
    width = parseFloat(widthMatch[1]);
  }

  // Remove all formatting codes
  cleanText = text
    .replace(/\\H[0-9.]+;/g, '')    // Remove height codes
    .replace(/\\W[0-9.]+;/g, '')    // Remove width codes
    .replace(/\\Q[0-9.]+;/g, '')    // Remove quality codes
    .replace(/\\[A-Za-z][^;]*;/g, '') // Remove other formatting codes
    .replace(/\\P/g, '\n')          // Convert \P to newline
    .replace(/\{|\}/g, '')          // Remove curly braces
    .replace(/^\s+|\s+$/g, '');     // Trim whitespace

  return { text: cleanText, height, width };
};

export default parseText;